<template>
  <div id="container">
    <div class="spnod-admin__account--section">
      <h5 class="spnod-admin__account--header">Subscription Details</h5>
      <b-row>
        <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">Name: </span>{{ sub.name || 'N/A' }}</b-col>
        <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">Plan: </span>{{ sub.planName || 'N/A' }}</b-col>
      </b-row>
    </div>
    <div class="spnod-admin__account--section">
      <h5 class="spnod-admin__account--header">Billing</h5>
      <b-row>
        <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">Created: </span>{{ sub.createdString || 'N/A' }}</b-col>
        <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">Status: </span>{{ sub.status || 'N/A' }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="12" xl="6" class="pb-2">
          <p v-if="!sub.cancel_at_period_end"><span class="text-muted">Due: </span>{{ sub.due || 'N/A' }}</p>
          <p v-else><span class="text-muted">Ends on: </span>{{ sub.ends_on || 'N/A' }}</p>
        </b-col>
        <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">Set to cancel: </span>{{ sub.cancel_at_period_end ? 'Yes' : 'No' }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">Price: </span>{{ sub.price || 'N/A' }}</b-col>
      </b-row>
    </div>
    <b-form-row class="d-flex justify-content-between px-1">
      <b-form-group>
        <b-button v-if="!sub.cancel_at_period_end" class="bg-danger" size="sm" v-b-modal="modals.delete._id">
          <p v-if="!isDeleting">Cancel Subscription</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
      </b-form-group>
      <b-form-group class="d-flex justify-content-end flex-grow">
        <b-button class="spnod-admin__form--button" @click="$router.go(-1)" size="sm">Back</b-button>
      </b-form-group>
    </b-form-row>

    <!--  Delete Modal  -->
    <Modal
      :_id="modals.delete._id"
      :message="modals.delete.message"
      @success="handleDelete" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Modal from '../../components/Notifications/Modal'

export default {
  name: 'EditSubscription',
  components: { Modal },
  data() {
    return {
      sub: {},
      modals: {
        delete: {
          _id: 'delete',
          message: 'Are you sure you want to cancel this subscription?'
        }
      },
      isDeleting: false
    }
  },
  computed: {
    ...mapGetters(['subscriptionToEdit']),
    group() {
      if (this.sub.plan && this.sub.plan.metadata && this.sub.plan.metadata.group) return this.sub.plan.metadata
    }
  },
  methods: {
    ...mapActions(['cancelSubscription']),
    handleDelete: async function() {
      this.isDeleting = true
      await this.cancelSubscription(this.sub)
      this.$router.push('/subscriptions')
      this.isDeleting = false
    }
  },
  mounted() {
    this.sub = this.subscriptionToEdit
    this.sub.createdString = moment.unix(this.sub.created).format('MM/DD/YYYY')
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/app/Pages/ManageSubscription/EditSubscription.vue?13853a76